import _inject from "@stylexjs/stylex/lib/stylex-inject";
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import React from 'react';
import Flex from "noood/comp/ui/containers/Flex";
import * as stylex from "@stylexjs/stylex";
export default function NoodleModalContentFromAPIResponse(props) {
  var _props$response, _props$response2, _props$response3;
  return /*#__PURE__*/React.createElement(React.Fragment, null, ((_props$response = props.response) === null || _props$response === void 0 || (_props$response = _props$response.success) === null || _props$response === void 0 ? void 0 : _props$response.length) > 0 && /*#__PURE__*/React.createElement(Flex, {
    isHorizontal: false,
    gap: 5,
    alignItems: "flex-start"
  }, props.response.success.map(function (success, idx) {
    return /*#__PURE__*/React.createElement("div", _extends({
      key: "modal-resp-s-".concat(idx)
    }, {
      className: "NoodleModalContentFromAPIResponse__ui.success ev1vy04vk"
    }), success);
  })), ((_props$response2 = props.response) === null || _props$response2 === void 0 || (_props$response2 = _props$response2.error) === null || _props$response2 === void 0 ? void 0 : _props$response2.length) === 1 && /*#__PURE__*/React.createElement(React.Fragment, null, props.response.error.map(function (error, idx) {
    return /*#__PURE__*/React.createElement("span", _extends({}, {
      className: "NoodleModalContentFromAPIResponse__ui.error ev17q8loj"
    }, {
      key: "modal-resp-e-".concat(idx)
    }), error);
  })), ((_props$response3 = props.response) === null || _props$response3 === void 0 || (_props$response3 = _props$response3.error) === null || _props$response3 === void 0 ? void 0 : _props$response3.length) > 1 && /*#__PURE__*/React.createElement("ul", {
    style: {
      padding: 0,
      margin: "10px"
    }
  }, props.response.error.map(function (e, idx) {
    return /*#__PURE__*/React.createElement("li", {
      className: 'modal-content-error-msg',
      key: "modal-resp-error-".concat(idx)
    }, e);
  })));
}

// @ts-ignore
_inject(".ev1vy04vk{color:var(--text-success)}", 3000);
_inject(".ev17q8loj{color:var(--text-error)}", 3000);